import React from 'react'
import styled from 'styled-components'
import { TimeInput } from '../../common'

const Wrapper = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
`

const InputBlock = styled.div`
    display: flex;
    flex-direction: column;
`

const Label = styled.span`
    font-size: 12px;
    font-weight: 500;
    color: ${props => props.theme.colors.mediumGrey};
`

const InputSeparator = styled.div`
    padding: 0 20px;
    font-size: 14px;
    font-style: italic;
    color: ${props => props.theme.colors.mediumGrey};
`

export const TimeInputGroup = ({fromTime, toTime, onChangeFromTime, onChangeToTime}) => {

    return (
        <Wrapper>
            <InputBlock>
                <Label>
                    Horário Inicial
                </Label>
                <TimeInput value={fromTime} onChange={onChangeFromTime} />
            </InputBlock>
            <InputSeparator>
                às
            </InputSeparator>
            <InputBlock>
                <Label>
                    Horário Inicial
                </Label>
                <TimeInput value={toTime} onChange={onChangeToTime} />
            </InputBlock>
        </Wrapper>
    )
}